import { render } from "./TeacherStatus.vue?vue&type=template&id=7fae310f&scoped=true"
import script from "./TeacherStatus.vue?vue&type=script&lang=js"
export * from "./TeacherStatus.vue?vue&type=script&lang=js"

import "./TeacherStatus.vue?vue&type=style&index=0&id=7fae310f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fae310f"]])

export default __exports__